module.exports = __webpack_public_path__ + "img/claim-promise.adb3c3c.svg";